export default __webpack_public_path__ + "static-front/media/refresh.9fbc58cf.svg";